import { eventManager } from '@breakmedia/prime-vue-event-manager';
import { onPageView } from './events/onPageView';
import { onProductPreview } from './events/onProductPreview';
import { onProductView } from './events/onProductView';
import { onBasketAdd, onBasketRemove } from './events/onBasketActions';
import { onInitiateCheckout } from './events/onInitiateCheckout';
import { onPurchase } from './events/onPurchase';
import { onConsentInit } from './events/onConsentInit';
import { onConsentUpdate } from './events/onConsentUpdate';

import Vue from 'vue';

const listeners = {
    productPreview: onProductPreview,
    productView: onProductView,
    basketAdd: onBasketAdd,
    basketRemove: onBasketRemove,
    purchase: onPurchase,
    pageView: onPageView,
    initiateCheckout: onInitiateCheckout,
    consentInit: onConsentInit,
    consentUpdate: onConsentUpdate,
};

const gtm = {
    dataLayerName: 'dataLayer',
    push(params) {
        window[this.dataLayerName].push(params);
    },
    gtag() {
        window[this.dataLayerName].push(arguments);
    },
    getProductObject(product, item) {
        let result = {};

        if (product && product.id) {
            let categories = '';
            let categoryList = {};
            let i = 0;

            for (let category of product.categories) {
                let categoryObject = Vue.$store.getters['SearchFilters/getCategoryById'](category);

                if (categoryObject) {
                    categories += (categories.length ? ', ' : '') + categoryObject.label;
                }

                if (i === 0) {
                    categoryList.item_category = categoryObject.label;
                } else {
                    categoryList[`item_category${i}`] = categoryObject.label;
                }
                i++;
            }

            let price = product.price.price;
            if (item && item.price) {
                price = item.price;
            } else if (item && item.price_vat) {
                price = item.price_vat;
            }

            result = {
                name: Vue.$store.getters['Product/getProductAttributeByLanguage'](product, 'product.name'),
                item_name: Vue.$store.getters['Product/getProductAttributeByLanguage'](product, 'product.name'),
                id: product.id,
                item_id: product.id,
                price,
                category: categories,
                ...categoryList,
            };
        }

        return result;
    },
};

const init = function(win, doc, layer, id) {
    win[layer] = win[layer] || [];
    win[layer].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });

    var firstTag = doc.getElementsByTagName('script')[0],
        tag = doc.createElement('script'),
        dl = layer !== 'dataLayer' ? '&l=' + layer : '';

    tag.async = true;
    tag.src = 'https://www.googletagmanager.com/gtm.js?id=' + id + dl;
    firstTag.parentNode.insertBefore(tag, firstTag);
};

const registerListeners = function() {
    Object.keys(listeners).forEach(event => eventManager.$on(event, listeners[event]));
};

let gtmLoaded = false; // ** This flag ensures we only trigger once **

const triggerConsentInit = function() {
    if (gtmLoaded) return; // Do not trigger twice
    gtmLoaded = true; // Ensure this only runs once

    console.log('triggerConsentInit', Vue.$store.state.PRIVACY_MODULE);

    const consentData = Vue.$store.state.PRIVACY_MODULE.registeredItems.reduce((acc, item) => {
        (item.consentTypes || []).forEach(consentType => {
            acc[consentType] = Vue.$store.state.PRIVACY_MODULE[item.key] ? 'granted' : 'denied';
        });
        return acc;
    }, {});

    eventManager.$emit('consentInit', consentData);
};

const waitForGtmToLoad = (callback) => {
    window.dataLayer = window.dataLayer || [];
    const checkForGtmLoad = () => {
        if (gtmLoaded) return; // Stop if GTM has already loaded

        const foundGtmJs = window.dataLayer.some(event => event.event === 'gtm.js');
        if (foundGtmJs) {
            callback();
        }
    };

    // ** Only listen for GTM load once **
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function() {
        Array.prototype.push.apply(this, arguments);
        checkForGtmLoad();
        return originalPush.apply(this, arguments);
    };

    // Check if 'gtm.js' is already in the dataLayer
    checkForGtmLoad();
};

export default {
    install(Vue, options) {
        let dataLayerName = options.dataLayerName || 'dataLayer';

        gtm.dataLayerName = dataLayerName;

        Vue.prototype.$gtm = gtm;
        Vue.$gtm = gtm;

        if (Vue.$store.state.PRIVACY_MODULE) {
            Vue.$store.watch(
                () => Vue.$store.state.PRIVACY_MODULE.measurement,
                value => {
                    if (value === true) {
                        init(window, document, dataLayerName, Vue.$config.VUE_APP_GTM_ID);
                        registerListeners();
                        waitForGtmToLoad(triggerConsentInit);
                    }
                },
                {
                    immediate: true,
                },
            );
        } else {
            init(window, document, dataLayerName, Vue.$config.VUE_APP_GTM_ID);
            registerListeners();
            waitForGtmToLoad(triggerConsentInit);
        }
    },
};
